import { lazy } from 'react'

const RELOAD_FLAG = 'wl:chunk-reload'

/**
 * React.lazy with a one-shot recovery for stale deployments.
 *
 * After a release, a tab that loaded the previous index.html still references
 * old chunk filenames. If the server has already dropped them, the dynamic
 * import rejects (ChunkLoadError / "Failed to fetch dynamically imported
 * module"). We reload the page once so the browser picks up the new
 * index.html; a sessionStorage flag prevents a reload loop if the chunk is
 * genuinely missing. This is what lets a deploy replace /assets outright
 * instead of keeping old chunks around.
 */
export function lazyWithReload(importer) {
  return lazy(() =>
    importer()
      .then((mod) => {
        try { sessionStorage.removeItem(RELOAD_FLAG) } catch { /* storage may be blocked */ }
        return mod
      })
      .catch((err) => {
        let alreadyReloaded = false
        try {
          alreadyReloaded = sessionStorage.getItem(RELOAD_FLAG) === '1'
          if (!alreadyReloaded) sessionStorage.setItem(RELOAD_FLAG, '1')
        } catch { /* storage may be blocked */ }

        if (!alreadyReloaded && typeof window !== 'undefined') {
          window.location.reload()
          // Keep the promise pending; the page is going away.
          return new Promise(() => {})
        }
        throw err
      })
  )
}
